// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const connector_sync_runsSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  configId: z.string().max(100),
  providerId: z.string().max(100),
  endpointId: z.string().max(100).optional(),
  startedAt: z.string().max(200).datetime(),
  completedAt: z.string().max(200).datetime(),
  status: z.string().max(50),
  triggeredBy: z.string().max(200),
  recordsRead: z.number().int(),
  inserts: z.number().int(),
  updates: z.number().int(),
  errors: z.number().int(),
  errorMessage: z.string().max(200).optional(),
  durationMs: z.number().int(),
  archived: z.boolean(),
})

export type Connector_sync_runsInput = z.infer<typeof connector_sync_runsSchema>
